import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Icon, type IconName } from '../../design/Icon';

/** Repère des cartes dont les données sont des exemples : elles ne doivent jamais passer pour de vraies données. */
export function PreviewBadge() {
  return <span className="lh-badge lh-badge-info" title="Données d’exemple : ce service n’est pas encore disponible">Aperçu</span>;
}

/**
 * Carte résumé d'un service (maquette 2a) : icône, titre, lien « ouvrir → » sur toute la carte quand le service
 * est disponible. Sans `to`, la carte n'est pas cliquable.
 */
export function ServiceCard({
  title,
  icon,
  to,
  preview = false,
  busy = false,
  children,
}: {
  title: string;
  icon?: IconName;
  to?: string;
  preview?: boolean;
  busy?: boolean;
  children?: ReactNode;
}) {
  return (
    <article className="hm-card" data-link={to ? 'true' : 'false'} aria-busy={busy || undefined}>
      <header className="hm-card__head">
        {icon ? <Icon name={icon} size={24} /> : null}
        <h2 className="hm-card__title">{title}</h2>
        {preview ? <PreviewBadge /> : null}
        {to ? (
          <Link to={to} className="hm-card__open">
            ouvrir<span className="sr-only"> {title}</span> <Icon name="arrowright" size={16} />
          </Link>
        ) : null}
      </header>
      {children}
    </article>
  );
}
